import { House as HomeIcon } from "@phosphor-icons/react"

export default HomeIcon
